<app-breadcrumbs></app-breadcrumbs>
<!-- Hero / Origin Section -->
<div class="relative w-full h-[500px] overflow-hidden">
  <!-- Background Image -->
  <img
    src="https://images.mashhoorplus.in/file/mashhoor-plus.png"
    alt="Mashhoor Plus"
    class="w-full h-full object-cover brightness-75"
  />
  <!-- Gradient Overlay -->
  <div class="absolute inset-0 bg-gradient-to-tr from-black/70 via-slate-900/50 to-transparent z-10"></div>

  <!-- Text Content -->
  <div class="absolute inset-0 z-20 flex items-center justify-center px-6 md:px-20">
    <div class="text-white max-w-2xl text-center md:text-left space-y-4">
      <h1 class="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-blue-400 to-emerald-400 bg-clip-text text-transparent">
        Origin
      </h1>
      <p class="text-sm md:text-base leading-relaxed text-slate-200">
        He was so keenly interested in Ayurveda that he would look for treatments for any health problems in Ayurveda.
        He believed that Ayurveda had a permanent cure for the majority of health problems. Interestingly, he had a
        collection of over 2500 books related to Ayurveda in his home library in Meerut, Uttar Pradesh.
      </p>
    </div>
  </div>
</div>

<!-- Story Timeline Section -->
<div class="w-full from-gray-900 via-slate-900 to-gray-800 py-16 px-4 md:px-20">
  <div class="max-w-5xl mx-auto space-y-16">

    <!-- Story Card 1 -->
    <div class="flex flex-col md:flex-row items-center gap-8">
      <img
        src="https://images.mashhoorplus.in/file/WhatsApp-Image-2025-01-07-at-4.48.23-PM.jpeg"
        alt="Hair Fall Discovery"
        class="w-64 h-64 rounded-2xl shadow-md object-cover border border-slate-700"
      />
      <p class="text-black text-lg leading-relaxed">
        A few years later he encountered a sudden increase in his hair fall. He once again looked towards Ayurveda to
        find a cure & the recipe for a hair oil was formulated. But, there were a few inconsistencies in the
        effectiveness during his first attempt at making the oil. And being engrossed in his textile business, Nanaji
        couldn’t find time to modify & improve the formula.
      </p>
    </div>

    <!-- Story Card 2 -->
    <div class="flex flex-col md:flex-row-reverse items-center gap-8">
      <img
        src="https://images.mashhoorplus.in/file/WhatsApp-Image-2025-01-07-at-4.24.03-PM.jpeg"
        alt="Improved Formula"
        class="w-64 h-64 rounded-2xl shadow-md object-cover border border-slate-700"
      />
      <p class="text-black text-lg leading-relaxed">
        With time, his commitment to Ayurveda never faded. He passed on his knowledge, which became the foundation of
        Mashhoor Plus. The hair oil formula was refined and turned into what is now a trusted product, bringing relief
        to thousands.
      </p>
    </div>

  </div>
</div>
